
import React, { createContext, useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '../api/axios';
import { toast } from 'react-toastify';

export const AuthContext = createContext();

// 8 hour max session lifetime before forcing re-login
const SESSION_MAX_MS = 8 * 60 * 60 * 1000;

export const useAuth = async () => {
    return useContext(AuthContext);
}

export const AuthProvider = ({ children }) => {
    const navigate = useNavigate();
    const [user, setUser] = useState(null);
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        try {
            const stored = JSON.parse(sessionStorage.getItem('user'));
            const loginTimestamp = Number(sessionStorage.getItem('loginTimestamp') || 0);

            if (stored && loginTimestamp && (Date.now() - loginTimestamp) < SESSION_MAX_MS) {
                setUser(stored);
                setIsAuthenticated(true);
            } else if (stored) {
                // Token present but session stale — clear and force re-login
                sessionStorage.clear();
                setUser(null);
                setIsAuthenticated(false);
            }
        } catch (e) {
            sessionStorage.clear();
        }
        // Note: sessionStorage already clears itself when the tab closes —
        // no beforeunload handler needed (and adding one also clears on reload).
    }, []);

    const handelLogin = async (e) => {
        try {
            e.preventDefault();
            setLoading(true);

            const formData = new FormData(e.currentTarget)
            const username = formData.get('username')
            const password = formData.get('password')

            const respons = await api.post(`/admin/login`, { username, password });



            sessionStorage.setItem('user', JSON.stringify(respons.data));
            sessionStorage.setItem('loginTimestamp', String(Date.now()));
            setUser(respons.data);
            setIsAuthenticated(true);

            toast.success('Login successful');
        } catch (error) {
            if (error.status === 401) {
                return toast.error('Invalid username or password');
            }

            console.error('Login failed:', error);
            return toast.error('Login failed');
        }
        finally {
            setTimeout(() => {
                setLoading(false);
            }, 2000);
        }
    }

    const hadnelLogout = async () => {
        try {
            sessionStorage.clear();
            setIsAuthenticated(false)
            setUser(null);
            navigate('/login');
        } catch (error) {
            console.error("Logout Error: ", error);

        }
    }


    return (
        <AuthContext.Provider value={{ handelLogin, hadnelLogout, setLoading, user, isAuthenticated, loading }}>
            {children}
        </AuthContext.Provider>
    );
};
